import React from 'react'
import { Button } from 'react-bootstrap'
import TypeLabel from '../../learning-resource/type-label'
import useLearningResourceView from './use-learning-resource-view'


const LearningResourcesCard = ({
    resource = {}
}) => {
    const { goToResource } = useLearningResourceView({ id: resource?.id })
    return (
        <Button
            size='sm'
            onClick={goToResource}
            disabled={!resource.url}
        >
            GO TO <TypeLabel resource={resource} />
        </Button>
    )
}

export default LearningResourcesCard